import { __require as f } from "./_castSlice.js";
import { __require as m } from "./_hasUnicode.js";
import { __require as v } from "./_stringToArray.js";
import { __require as d } from "./toString.js";
var i, a;
function C() {
  if (a) return i;
  a = 1;
  var t = f(), o = m(), u = v(), s = d();
  function c(_) {
    return function(r) {
      r = s(r);
      var e = o(r) ? u(r) : void 0, n = e ? e[0] : r.charAt(0), q = e ? t(e, 1).join("") : r.slice(1);
      return n[_]() + q;
    };
  }
  return i = c, i;
}
export {
  C as __require
};
